import { render } from "./KpiViewer.vue?vue&type=template&id=975b14ec&scoped=true"
import script from "./KpiViewer.vue?vue&type=script&lang=js"
export * from "./KpiViewer.vue?vue&type=script&lang=js"

import "./KpiViewer.vue?vue&type=style&index=0&id=975b14ec&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-975b14ec"]])

export default __exports__